import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './BlogOverview';

const BlogOverviewSuspense = dynamic(() => import('./BlogOverview'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicBlogOverview(props: Props) {
	return <BlogOverviewSuspense {...props} />;
}
DynamicBlogOverview.displayName = 'DynamicBlogOverview';
